<app-selection-buttons-container
  [buttonsArrayBehaviorSubject]="platformSelectionButtons"
  [title]="getPlatformTitle()"
  (buttonOnClick)="onPlatformSelected($event)"
>
</app-selection-buttons-container>

<div *ngIf="!disabled" class="separator-section">
  <div class="separator"></div>
</div>
<app-select
  *ngIf="!disabled"
  class="drop-down"
  [placeHolder]="'integrationPage.platformDropDownPlaceHolder' | labelsProvider"
  [options]="platformsListOptions"
  (optionOnSelection)="onMorePlatformSelected($event)"
  [withoutShowingSelection]="true"
>
</app-select>
